import { render, staticRenderFns } from "./OfferCampagin.vue?vue&type=template&id=6bcf6ee3&scoped=true"
import script from "./OfferCampagin.vue?vue&type=script&lang=js"
export * from "./OfferCampagin.vue?vue&type=script&lang=js"
import style0 from "./OfferCampagin.vue?vue&type=style&index=0&id=6bcf6ee3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcf6ee3",
  null
  
)

export default component.exports